import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";

export var adminRights = function adminRights(userRoles) {
  return (
    _includesInstanceProperty(userRoles).call(userRoles, 'ADMIN') || _includesInstanceProperty(userRoles).call(userRoles, 'CELTICS') || _includesInstanceProperty(userRoles).call(userRoles, 'IM_CELTICS'));

};

export var celticsRights = function celticsRights(userRoles) {
  return _includesInstanceProperty(userRoles).call(userRoles, 'CELTICS') || _includesInstanceProperty(userRoles).call(userRoles, 'IM_CELTICS');
};

export var eeRights = function eeRights(userRoles) {
  return _includesInstanceProperty(userRoles).call(userRoles, 'EMPLOYEE') || _includesInstanceProperty(userRoles).call(userRoles, 'EMPLOYER');
};

export var brokerRights = function brokerRights(userRoles) {
  return _includesInstanceProperty(userRoles).call(userRoles, 'BROKER');
};

export var employerRights = function employerRights(userRoles) {
  return _includesInstanceProperty(userRoles).call(userRoles, 'EMPLOYER');
};

export var employeeRights = function employeeRights(userRoles) {
  return _includesInstanceProperty(userRoles).call(userRoles, 'EMPLOYEE');
};

export var imCelticsRights = function imCelticsRights(userRoles) {
  return _includesInstanceProperty(userRoles).call(userRoles, 'IM_CELTICS');
};

export var userAccessRights = function userAccessRights(userRoles) {
  return _includesInstanceProperty(userRoles).call(userRoles, 'USER_ACCESS');
};
//# sourceMappingURL=accessRights.js.map